import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Leaf } from 'lucide-react';

export default function Terms() {
    return (
        <div className="min-h-screen bg-bone text-ink" data-testid="terms-page">
            <header className="max-w-3xl mx-auto px-6 py-6 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-2 text-sm text-inkSoft hover:text-ink">
                    <ArrowLeft className="w-4 h-4"/> Tilbake
                </Link>
                <div className="flex items-center gap-2">
                    <div className="w-7 h-7 rounded-full bg-sage flex items-center justify-center">
                        <Leaf className="w-3.5 h-3.5 text-bone" />
                    </div>
                    <span className="font-display font-bold tracking-tight">Stillerom</span>
                </div>
            </header>

            <main className="max-w-3xl mx-auto px-6 pb-24">
                <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight mt-6">Vilkår for bruk</h1>
                <p className="text-sm text-inkSoft mt-2">Sist oppdatert: {new Date().toLocaleDateString('nb-NO')}</p>

                <div className="mt-8 text-ink space-y-6">
                    <section>
                        <h2 className="font-display text-xl font-semibold">1. Tjenesten</h2>
                        <p>Stillerom er en anonym samtaletjeneste der du kan snakke med en AI-basert samtalepartner. Tjenesten er utformet som et lavterskeltilbud for refleksjon og selvhjelp.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl font-semibold">2. Ikke profesjonell helsehjelp</h2>
                        <p>Stillerom er <strong>ikke</strong> en erstatning for psykolog, lege eller annen helsepersonell. Samtalepartneren kan ikke stille diagnose eller gi medisinske råd. Ved akutt krise: ring Mental Helse 116 123 eller 113.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl font-semibold">3. Alder</h2>
                        <p>Du må være minst <strong>16 år</strong> for å bruke tjenesten. Er du under 18, anbefaler vi at du snakker med en voksen du stoler på, eller Kors på halsen 800 33 321 / Alarmtelefon 116 111.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl font-semibold">4. Medlemskap og priser</h2>
                        <ul className="list-disc pl-5 space-y-1">
                            <li><strong>Gratis</strong>: 10 meldinger total uten kort. Valgfri 3-dagers gratis Premium uten kort.</li>
                            <li><strong>Basic – 99 kr/mnd</strong>: 30 minutter samtale per dag.</li>
                            <li><strong>Premium – 199 kr/mnd</strong>: ubegrenset bruk.</li>
                        </ul>
                        <p>Betalinger behandles av Stripe. Medlemskap løper 30 dager fra kjøp og fornyes <strong>ikke</strong> automatisk – du må aktivt forny hver 30. dag. Refusjon gis innen 14 dager ved ubrukte medlemskap (angrerett).</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl font-semibold">5. Forventet bruk</h2>
                        <p>Du forplikter deg til å bruke tjenesten lovlig og ikke:</p>
                        <ul className="list-disc pl-5 space-y-1">
                            <li>Misbruke tjenesten til å skade andre</li>
                            <li>Prøve å omgå tekniske begrensninger</li>
                            <li>Opprette mange kontoer for å omgå grenser</li>
                            <li>Bruke automatiserte verktøy uten tillatelse</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="font-display text-xl font-semibold">6. Anonymitet</h2>
                        <p>Du velger selv om du oppgir alias eller ekte navn. Vi oppfordrer til anonymitet. Del aldri sensitiv personinfo om andre i samtalen.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl font-semibold">7. Ansvarsbegrensning</h2>
                        <p>Tjenesten leveres "som den er". Vi er ikke ansvarlige for beslutninger du tar basert på samtaler i appen. Maks ansvar er begrenset til siste 12 måneders betalt medlemskap.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl font-semibold">8. Opphør</h2>
                        <p>Du kan si opp når som helst ved å slette kontoen. Vi kan suspendere kontoer som bryter vilkårene.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl font-semibold">9. Lovvalg</h2>
                        <p>Norsk rett gjelder. Tvister løses av norske domstoler.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl font-semibold">10. Kontakt</h2>
                        <p><a href="mailto:hei@stillerom.no" className="text-sage-dark underline">hei@stillerom.no</a></p>
                    </section>
                </div>
            </main>
        </div>
    );
}
